import { refreshTokenKey, setRefreshToken } from "@/utils/token-manager";
import { dashboardUrl } from "@/utils/constants";

export interface TokenBundle {
  accessTokenString: string;
  accessExpireAt: string;
  refreshTokenString?: string;
  refreshExpireAt?: string;
}

/**
 * Persists tokens to localStorage/cookie and redirects to the dashboard
 * login-success handoff URL.
 *
 * This is the single place that owns the token-persistence + redirect logic
 * so that login.tsx, mfa-challenge, and change-password-required all behave
 * identically on the plain (non-beta) path.
 */
export function postLoginHandoff({
  accessTokenString,
  accessExpireAt,
  refreshTokenString,
  refreshExpireAt,
}: TokenBundle) {
  window.localStorage.setItem("accessToken", accessTokenString);
  window.localStorage.setItem("expireAt", accessExpireAt);

  let url = `${dashboardUrl}/login-success?accessToken=${accessTokenString}&expireAt=${accessExpireAt}`;

  if (refreshTokenString) {
    setRefreshToken(refreshTokenKey, refreshTokenString, refreshExpireAt ?? "");
    url += `&refreshToken=${refreshTokenString}&refreshExpireAt=${refreshExpireAt ?? ""}`;
  }

  window.location.href = url;
}
